import { createRoot } from 'react-dom/client';
import App from './App';
import ApplicationLoadRecoveryBoundary from '../../../matter-platform/src/kernel/app-shell/ApplicationLoadRecoveryBoundary.tsx';
import { installStaleBuildRecovery } from '../../../matter-platform/src/kernel/app-shell/stale-build-recovery.ts';
import { markApplicationStartupPhase } from '../../../matter-platform/src/kernel/performance/application-startup-performance.ts';
import '../../../matter-platform/src/kernel/content-presentation/links.css';
import '../../../matter-platform/src/kernel/content-presentation/lists.css';
import './index.css';

markApplicationStartupPhase('entryLoaded');
installStaleBuildRecovery();
const applicationRoot = document.getElementById('root');
if (!applicationRoot) throw new Error('Application root element "#root" is missing');
createRoot(applicationRoot).render(
  <ApplicationLoadRecoveryBoundary>
    <App />
  </ApplicationLoadRecoveryBoundary>,
);
